import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Icon from './AppIcon';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, loading, userProfile, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Icon name="Loader2" size={32} className="text-primary animate-spin" />
          <p className="text-muted-foreground text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    // Redirect resellers to their portal, others to dashboard
    const redirectPath = userProfile?.role === 'reseller' ? '/reseller-portal' : '/dashboard-home';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
